import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IAdd = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={props.svgStyle??{ marginRight:"3px",marginTop:"2px",marginLeft:"-1px" }}
            width={props.width??"20"}
            height={props.height??"20"}
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10 0C4.489 0 0 4.489 0 10C0 15.511 4.489 20 10 20C15.511 20 20 15.511 20 10C20 4.489 15.511 0 10 0ZM10 2C14.4301 2 18 5.56988 18 10C18 14.4301 14.4301 18 10 18C5.56988 18 2 14.4301 2 10C2 5.56988 5.56988 2 10 2ZM9 5V9H5V11H9V15H11V11H15V9H11V5H9Z"
              fill={props.color??"#37474F"}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IAdd;
